import React, { useState } from "react";
import { Pencil, Trash2, Eye } from "lucide-react";
import TeacherObservationModal from "../../../modals/admin/survey/TeacherObservationModal";

function TeacherObservation() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedObservation, setSelectedObservation] = useState(null);

  const dummyData = [
    {
      studentId: "STD001",
      studentName: "John Smith",
      class: "Grade 8",
      section: "A",
      subject: "Mathematics",
      teacherName: "Mrs. Anderson",
      observationDetails: {
        classroomManagement: "Excellent",
        teachingMethods: "Very effective",
        studentEngagement: "High",
        lessonPlanning: "Well structured",
        comments: "Shows great command over the subject and maintains good classroom discipline"
      }
    },
    {
      studentId: "STD002", 
      studentName: "Sarah Wilson",
      class: "Grade 7",
      section: "B",
      subject: "Science",
      teacherName: "Mr. Roberts",
      observationDetails: {
        classroomManagement: "Good",
        teachingMethods: "Interactive",
        studentEngagement: "Moderate",
        lessonPlanning: "Organized",
        comments: "Uses creative teaching methods but needs improvement in time management"
      }
    }
  ];

  const handleViewDetails = (observation) => {
    setSelectedObservation(observation);
    setIsModalOpen(true);
  };

  const handleEdit = (observation) => {
    // Handle edit functionality
    console.log("Edit:", observation);
  };

  const handleDelete = (observation) => {
    // Handle delete functionality
    console.log("Delete:", observation);
  };

  return (
    <div>
      <div className="overflow-x-auto mt-6">
        <table className="table-auto w-full mt-6">
          <thead className="py-4 border-b font-bold">
            <tr className="bg-gray-100 border-b">
              <th className="p-3">Student ID</th>
              <th className="p-3">Student Name</th>
              <th className="p-3">Class</th>
              <th className="p-3">Section</th>
              <th className="p-3">Subject</th>
              <th className="p-3">Teacher Name</th>
              <th className="p-3">Observation Report</th>
              <th className="p-3">Actions</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {dummyData.map((observation, index) => (
              <tr key={index} className="hover:bg-gray-200 border-b">
                <td className="p-3">{observation.studentId}</td>
                <td className="p-3">{observation.studentName}</td>
                <td className="p-3">{observation.class}</td>
                <td className="p-3">{observation.section}</td>
                <td className="p-3">{observation.subject}</td>
                <td className="p-3">{observation.teacherName}</td>
                <td className="p-3">
                  <button
                    className="bg-[#241763] text-white px-3 py-1 rounded hover:bg-[#241763]/80"
                    onClick={() => handleViewDetails(observation)}
                  >
                    View Details
                  </button>
                </td>
                <td className="p-3 space-x-2 flex items-center">
                  <button
                    className="bg-[#B6A5C9]/50 text-white p-2 rounded hover:bg-[#241763]/60 group"
                    onClick={() => handleDelete(observation)}
                  >
                    <Trash2 className="text-[#241763] w-4 h-4 group-hover:text-white" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <TeacherObservationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        observation={selectedObservation}
      />
    </div>
  );
}

export default TeacherObservation;
